import React from 'react';

const PhoneTableHeader = () => {
  return (
    <div style={{ display: 'flex', background: 'rgba(234, 246, 255, 1)' }}>
      <div
        style={{ width: '31%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Type
      </div>
      <div
        style={{ width: '31%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Additional Information
      </div>
      <div
        style={{ width: '31%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Number
      </div>
    </div>
  );
};

export default PhoneTableHeader;
